export default __webpack_public_path__ + "static/media/facebook.5f38218b.svg";